var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDsIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.75,
    cy: 35,
    r: 35,
    fill: "#FFF5D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_38455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2497 26.2501H41.9998V25C41.9998 23.6213 40.8786 22.5 39.4998 22.5H31.9998C30.621 22.5 29.4997 23.6212 29.4997 25V26.25H23.2498C21.8709 26.2501 20.7498 27.3713 20.7498 28.75V32.5C20.7498 33.8789 21.8709 35.0001 23.2498 35.0001H33.2498V34.375C33.2498 34.0296 33.5293 33.75 33.8748 33.75H37.6248C37.9703 33.75 38.2498 34.0296 38.2498 34.375V35.0001H48.2498C49.6286 35.0001 50.7498 33.8789 50.7498 32.5V28.75C50.7498 27.3713 49.6286 26.2501 48.2497 26.2501ZM39.4998 26.2501H31.9998V25H39.4998V26.2501Z",
    fill: "#FFBB38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4031 35.6744C50.1901 35.5688 49.9355 35.5933 49.7475 35.736C49.3032 36.0724 48.7856 36.25 48.2497 36.25H38.2498V38.125C38.2498 38.4704 37.9702 38.75 37.6248 38.75H33.8748C33.5293 38.75 33.2497 38.4704 33.2497 38.125V36.25H23.2498C22.7139 36.25 22.1963 36.0724 21.7519 35.736C21.5633 35.592 21.3094 35.5676 21.0964 35.6744C20.8841 35.78 20.7498 35.9967 20.7498 36.2342V45C20.7498 46.3788 21.8709 47.5 23.2498 47.5H48.2498C49.6286 47.5 50.7498 46.3789 50.7498 45V36.2342C50.7498 35.9967 50.6155 35.78 50.4031 35.6744Z",
    fill: "#FFBB38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_38455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(20.7498 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsIcon02);
export default __webpack_public_path__ + "static/media/ds_icon_02.c80ca90a45e319ccf6ea4e6a6b3f90f0.svg";
export { ForwardRef as ReactComponent };